import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import FileUploadInput from '../../common/FileUploadInput';

const FileUploadInputComponent = () => {
    const handleFileUpload = (files) => {
        console.log('Uploaded Files:', files);
    };

    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">File Upload Input Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <FileUploadInput
                                    label="Upload Your File"
                                    required={true}
                                    onFileUpload={handleFileUpload}
                                    showHelp={true}
                                    helpText="Please upload a file."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<FileUploadInput
    label="Upload Your File"
    required={true}
    onFileUpload={handleFileUpload}
    showHelp={true}
    helpText="Please upload a file."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <FileUploadInput
                                    label="Upload Images Only"
                                    acceptedTypes={['image/jpeg', 'image/png']}
                                    required={true}
                                    onFileUpload={handleFileUpload}
                                    showHelp={true}
                                    helpText="You can only upload JPEG or PNG images."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<FileUploadInput
    label="Upload Images Only"
    acceptedTypes={['image/jpeg', 'image/png']}
    required={true}
    onFileUpload={handleFileUpload}
    showHelp={true}
    helpText="You can only upload JPEG or PNG images."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <FileUploadInput
                                    label="Upload PDF Document"
                                    acceptedTypes={['application/pdf']}
                                    maxSize={5 * 1024 * 1024} // 5 MB
                                    required={true}
                                    onFileUpload={handleFileUpload}
                                    showHelp={false}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<FileUploadInput
    label="Upload PDF Document"
    acceptedTypes={['application/pdf']}
    maxSize={5 * 1024 * 1024} // 5 MB
    required={true}
    onFileUpload={handleFileUpload}
    showHelp={false}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <FileUploadInput
                                    label="Upload Multiple Files"
                                    acceptedTypes={['application/pdf', 'image/jpeg', 'image/png']}
                                    required={false}
                                    onFileUpload={handleFileUpload}
                                    showHelp={true}
                                    helpText="You can upload multiple files."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<FileUploadInput
    label="Upload Multiple Files"
    acceptedTypes={['application/pdf', 'image/jpeg', 'image/png']}
    required={false}
    onFileUpload={handleFileUpload}
    showHelp={true}
    helpText="You can upload multiple files."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default FileUploadInputComponent;
